import { ShipmentPartAllocationDetail } from "../../../../utils/hooks/inventory/shipmentsThatNeedPart";
import { BoardPartOptionDetails } from "./InventoryUpdatesStyles";
import { InputLabel, PropertyContainer } from "../../../../constants/Styles";
import { ManufacturingStepStatus } from "../../../../reducers/uploadedBoard";
import Icon from "../../../common/Icon";
import React from "react";
import useBoardBin from "../../../../utils/hooks/commonly-stored/uploaded-board/boardBin";
import { dateStringToHumanReadableDate } from "../../../../utils/valueFormatting";
import { useShipment } from "../../../../utils/hooks/commonly-stored/uploaded-board/shipments";

export default function BoardNeedingPartDetails({
  allocationDetail,
}: {
  allocationDetail: ShipmentPartAllocationDetail;
}) {
  const { shipment } = useShipment(
    allocationDetail.board.id,
    allocationDetail.shipment_id,
  );
  const { inventoryBin } = useBoardBin(allocationDetail.board.id);
  return (
    <BoardPartOptionDetails>
      <PropertyContainer>
        <InputLabel>Project:</InputLabel>
        {allocationDetail.board.project_name} ({allocationDetail.board.id})
      </PropertyContainer>
      <PropertyContainer>
        <InputLabel>Board tote:</InputLabel>
        <div>
          {inventoryBin ? (
            <div>{inventoryBin.bin_name}</div>
          ) : (
            "No associated tote"
          )}
        </div>
      </PropertyContainer>
      <PropertyContainer>
        <InputLabel>Amount allocated / amount required:</InputLabel>
        {`${allocationDetail.total_allocated_amount} / ${allocationDetail.required_amount}`}
      </PropertyContainer>
      <PropertyContainer>
        <InputLabel>Ship date:</InputLabel>
        {shipment
          ? dateStringToHumanReadableDate(shipment.ship_date, true)
          : "-"}
      </PropertyContainer>
      <PropertyContainer>
        <InputLabel>Stencil:</InputLabel>
        <div>
          {shipment &&
          shipment.manufacturing_checklist.inventory_status.stencil ===
            ManufacturingStepStatus.READY ? (
            <Icon src={"/icons/check_green.svg"} alt={"check"} />
          ) : (
            "-"
          )}
        </div>
      </PropertyContainer>
      <PropertyContainer>
        <InputLabel>Panel:</InputLabel>
        <div>
          {shipment &&
          shipment.manufacturing_checklist.inventory_status.panel ===
            ManufacturingStepStatus.READY ? (
            <Icon src={"/icons/check_green.svg"} alt={"check"} />
          ) : (
            "-"
          )}
        </div>
      </PropertyContainer>
    </BoardPartOptionDetails>
  );
}
